import React from 'react';
import { getUrl, getDescText, getPageDateShort } from '../../common/services/builders';
import PropTypes from 'prop-types';

function FAQListerSearchItem({ entry }) {




    var getTextDirection = function () {
        if (entry.language != undefined && entry.language.name == "Arabic")
        {
            return "rtl";
        }
        
        return;


    };


    //var languageClass = "row column " + entry.language.name.toLowerCase();

    var category = "FAQ";
    var permissions = "Public";   

    if (entry.language != undefined && entry.language.name == "Arabic")
    {
        category = "التعليمات";
        permissions = "عامة";  

    }

    return (
        <div className="search-result">
            <div className="row">
                <div className="small-6 column">
                    
                    <span className="category--tag">{category}</span>
                </div>
                <div className="small-6 column text-right">
                    <span className="category--tag">{permissions}</span>
                </div>
            </div>

            
            <div className={getTextDirection()}>
                <h4><a href={getUrl(entry)}>{entry.title}</a></h4>
                <span dangerouslySetInnerHTML={{__html: getDescText(entry)}}></span>


                {<span className="date">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-clock"></use>
                    </svg>
                    {getPageDateShort(entry)}
                </span>}
            </div>
        </div>
    );
    
}
//January 20th 2021
//20 يناير 2021

FAQListerSearchItem.propTypes = {
    entry: PropTypes.object
};

export default FAQListerSearchItem;